import axiosClient from '@/config/api/axios'
import { DOCUMENTS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'
import { documentFromRow } from './documentMappers'

export function isDocumentsApiAvailable() {
  return isApiConfigured()
}

export async function fetchDocuments(options = {}) {
  if (!isDocumentsApiAvailable()) return []
  const { data } = await axiosClient.get(DOCUMENTS, { signal: options.signal })
  return (Array.isArray(data) ? data : []).map(documentFromRow)
}

export async function getDocument(id, options = {}) {
  if (!isDocumentsApiAvailable()) return null
  const { data } = await axiosClient.get(`${DOCUMENTS}/${id}`, { signal: options.signal })
  return documentFromRow(data)
}

export async function fetchDocumentPdf(id, options = {}) {
  if (!isDocumentsApiAvailable()) throw new Error('Documents API is not configured')
  const { data } = await axiosClient.get(`${DOCUMENTS}/${id}/file`, {
    params: { variant: 'render' },
    responseType: 'arraybuffer',
    signal: options.signal,
  })
  return data
}

export async function uploadDocument(file, options = {}) {
  if (!isDocumentsApiAvailable()) return null
  const form = new FormData()
  form.append('file', file)
  const params = {
    ...(options.projectId ? { project_id: options.projectId } : {}),
    ...(options.uploadId ? { upload_id: options.uploadId } : {}),
  }
  const { data } = await axiosClient.post(DOCUMENTS, form, { params, signal: options.signal })
  return documentFromRow(data)
}

export async function deleteDocument(id, options = {}) {
  if (!isDocumentsApiAvailable()) return
  await axiosClient.delete(`${DOCUMENTS}/${id}`, { signal: options.signal })
}
